import { ArrowDark } from '@mafc/icon';

import * as S from './LinkActionButton.style';
import { COLORS } from '@mafc/common';
import ThemeColors from 'theme/colors';

const LinkActionButton: React.FC<{
  dataTestId: string;
  label?: string;
  onClick?: () => void;
  disabled?: boolean;
}> = ({ onClick, label, dataTestId, disabled = false }) => {
  const onClickProp = onClick ? { onClick } : {};

  return (
    <S.ChangeButton disabled={disabled} variant="link" {...onClickProp} data-testid={dataTestId}>
      {label && <S.ChangeLabel as="span">{label}</S.ChangeLabel>}
      <ArrowDark
        size="CUSTOM"
        width="8px"
        height="15px"
        fill={disabled ? ThemeColors.GRAY_SCALE_100 : COLORS.BLUE}
      />
    </S.ChangeButton>
  );
};

export default LinkActionButton;
